import axios from 'axios';

// ─── Detección de entorno ────────────────────────────────
// En local (localhost, 127.0.0.1, 192.168.x.x, 10.x.x.x) usa el backend local.
// En producción (lluchunga.com) usa https://api.lluchunga.com.
const isDev =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  /^192\.168\./.test(window.location.hostname) ||
  /^10\./.test(window.location.hostname);

const baseURL = isDev
  ? `http://${window.location.hostname}:3000/api`
  : 'https://api.lluchunga.com/api';

console.log('API URL:', baseURL);

const api = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Si hay una finca activa seleccionada (para super_admin), enviarla como query param
  const fincaId = localStorage.getItem('fincaActivaId');
  if (fincaId) {
    config.params = { ...(config.params || {}), finca_id: fincaId };
  }

  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    console.error('ERROR API:', err.response?.status, err.response?.data, err.message);
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;